export default {
  auth: {},
  allowedShortcutChars: [
    ',',
    'B',
    'D',
    'E',
    'O',
    'R',
    'X',
  ],
  betMap: {
    B: 'black',
    D1: 'firstDozen',
    D2: 'secondDozen',
    D3: 'thirdDozen',
    E: 'even',
    O: 'odd',
    R: 'red',
  },
  betShortcuts: [],
  betslip: {
    tickets: [
      {
        id: 'single',
        active: true,
        betsCollection: 'SpinAndWin',
        betTemplate: 'generic',
        group: {
          id: 'SpinAndWin',
          taxesConfig: {
            payin: {
              value: false,
              hideTax: false,
            },
            payout: {
              value: false,
              hideTax: false,
            },
          },
        },
        ticketGroup: 'SpinAndWin',
        ticketType: {
          id: 3,
          name: 'single',
        },
        setStakeStrategy: 'sevenVirtualSetStake',
        setFormatPayin: 'sevenVirtualFormataPayin',
        autoStakeSetting: true,
        winningStrategy: false,
      },
    ],
  },
  config: {
    app: 'SpinAndWinShop',
    api: process.env.VUE_APP_API_URL,
    gateway: {
      masterOrigins: process.env.VUE_APP_GATEWAY_ORIGINS,
      slaveId: 'SpinAndWin',
      settings: {
        shop: {
          ticketConfig: {
            availableTicketActions: {
              closed: [
                { action: 'rebet', conditions: [] },
              ],
              open: [
                { action: 'cancel', conditions: [] },
                { action: 'printCopy', conditions: [] },
                { action: 'rebet', conditions: [] },
              ],
              lost: [
                { action: 'rebet', conditions: [] },
              ],
              payedout: [
                { action: 'reprintConfirmation', conditions: [] },
                { action: 'rebet', conditions: [] },
              ],
              pending: [
                { action: 'cancel', conditions: [] },
                { action: 'printCopy', conditions: [] },
                { action: 'rebet', conditions: [] },
              ],
              rejected: [
                { action: 'rebet', conditions: [] },
              ],
              won: [
                { action: 'payout', conditions: [] },
                { action: 'rebet', conditions: [] },
              ],
              won_overdue: [
                { action: 'payout', conditions: [] },
                { action: 'rebet', conditions: [] },
              ],
            },
            color: '#3EB489',
            doTicketStatusCheck: true,
            pendingTicketLimitTotal: 100,
            pendingTicketLimitByGame: 1,
            pendingTicketCheckInterval: 15000,
            pendingTicketRejectPeriod: 60000,
            sentTicketRejectPeriod: 10000,
            useTicketLocalStorage: true,
            validateTicket: false,
          },
          shortcuts: {},
          icon: 'n-i-roulette',
        },
      },
      keyListeners: '*',
      keyPropagation: [
        '111',
        '112',
        '113',
        '114',
        '115',
        '187',
        '16',
        '27',
        '32',
        '9',
      ],
    },
    locale: 'en',
    wheel: {},
  },
  platform: {},
  round: {},
  limits: {},
  updateBet: false,
  nextRounds: [],
  ticket: {
    bets: [
      /*
        betName: string,
        betSelection: array,
        displayBetName: string,
        displayName: string,
        displayValue: string,
        numberOfRounds: number,
        payment: number,
        round: number,
        payment: number,
      */
    ],
    payment: 0,
    payin: 0,
    winnings: {
      min: 0,
      max: 0,
    },
  },
  socketProvider: 'pusher',
  /* eslint-disable no-template-curly-in-string */
  translations: {
    betIdLabel: 'Bet ID',
    betOdds: 'Odds',
    betslipLabel: 'Betslip',
    bettingDisabled: 'Betting disabled',
    eventLabel: 'Event',
    invalidBetCount: 'Invalid number of bets. Maximum is ${maxBets}.',
    invalidBetPayment: 'Invalid bet payment. Minimum is ${ticketBetMinPayment}, maximum is ${ticketBetMaxPayment}.',
    invalidBetShortcutError: 'Invalid bet shortcut. Please check.',
    invalidTicketPayment: 'Invalid ticket payment. Minimum is ${ticketMinPayment}, maximum is ${ticketMaxPayment}.',
    payInLabel: 'Pay in',
    results: 'Results',
    roundInProgressLabel: 'in progress',
    roundLabel: 'Round',
    roundStartingInLabel: 'starting in',
    stakeLabel: 'Stake',
  },
  ui: {},
  user: {},
};
